import { useState } from "react";
import PhoneField from "../../components/PhoneField";
import { View } from "react-native";
import type { Meta, StoryObj } from "@storybook/react";

type StoryComponentProps = {
    initialValue?: string;
    label?: string;
    error?: string;
    disabled?: boolean;
};

function StoryComponent({ initialValue, label, error, disabled }: StoryComponentProps) {
    const [phone, setPhone] = useState(initialValue);

    return (
        <PhoneField
            value={phone}
            onPhoneNumberChanged={setPhone}
            label={label || "Enter your phone number"}
            error={error}
            disabled={disabled}
        />
    );
}

const meta = {
    title: "Fields/Phone",
    component: StoryComponent,
    argTypes: {},
    decorators: [
        (StoryFn) => (
            <View style={{ alignItems: "stretch", padding: 10 }}>
                <StoryFn />
            </View>
        ),
    ],
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {},
};

export const WithValue: Story = {
    args: {
        initialValue: "+41 79 999 99 01",
    },
};

export const WithError: Story = {
    args: {
        initialValue: "+4179",
        error: "Le numéro de téléphone n'est pas valide.",
    },
};

export const Disabled: Story = {
    args: {
        initialValue: "+41 79 999 99 01",
        disabled: true,
    },
};
